import { ShoppingBag, Circle } from 'react-feather'

export default [
	{
		id: 'shop',
		title: 'Cửa hàng',
		icon: <ShoppingBag size={20} />,
		children: [
			{
				id: 'taphoa',
				title: 'Tạp hoá',
				icon: <Circle size={12} />,
				navLink: '/shop/taphoa'
			},
			{
				id: 'event',
				title: 'Sự kiện',
				icon: <Circle size={12} />,
				navLink: '/shop/event'
			}
		]
	}
]
